import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import { ProjectData } from "../components/ProjectData";
import { ProjectKeyInformation } from "../components/ProjectKeyInformation";
import { EntityInCharge } from "../components/EntityInCharge";
import { ProjectFinancialData } from "../components/ProjectFinancialData";
import { ProjectDates } from "../components/ProjectDates";
import { RomReview } from "../components/RomReview";
import Button from "@material-ui/core/Button";
import { inject, observer } from "mobx-react";
import { stores } from "../store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CircularProgress from '@material-ui/core/CircularProgress';

import 'moment-timezone';
import moment from 'moment'

//import API from '../api'
const CreateProjectPage = inject("userStore")(observer(class CreateProjectPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            typeOfROM: "",
            projectTitle: "",
            projectNumber: "",
            status: "",
            typeOfProject: "",
            sector: "",
            smcsCode: "",
            cfcuContractManager: "",
            deuaSectorExpert: "",
            deuaMonitoringExpert: "",
            eudSectorManager: "",
            beneficiaryInstitution: "",
            beneficiaryUnitDepartment: "",
            contractingPartner: "",
            totalBudget: "",
            euContribution: "",
            nationalCoFinancing: "",
            otherCoFinancing: "",
            mainComponentBudget: "",
            totalFundsDisbursed: "",
            lastDateOfPayment: new Date(),
            contractorSignatureDate: new Date(),
            projectStartDate: new Date(),
            finalDate: new Date(),
            reasonfortheRomReview: "",
            romExpertName: "",
            coMonitor: "",
            fieldPhaseStartDate: new Date(),
            fieldPhaseEndDate: new Date(),
            contactAtBeneficiaryInstitution: "",
            teamLeaderPartner: "",
            annualType: 1,
            IPAType: 2,
            FAType: "",
            FAMAType: "",
            loading: true,
            notAuthorized: true,
            isFetching: false,
            beneficiaryInstitutionOptions: "",
            beneficiarieslist: "",
            userType: -1,
        };
    }

    async componentDidMount() {


        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        await this.getUserType();

        await this.loadPage();
    }

    handleChange = async (e) => {
        //console.log(e);
        console.log(e.target.name + " " + e.target.value);
        e.persist();
        await this.setState({ [e.target.name]: e.target.value });
    };

    handleChangeDate = (name, value) => {
        //console.log(name);
        //console.log(value);

        //this.setState({ [name]: new Date(value) });
        this.setState({ [name]: new Date(moment(value).format('YYYY-MM-DD')) });
    };

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectChangeUseValue = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeName });
        } else {
            await this.setState({ [vname]: "" });
        }

        console.log(this.state);
    }

    getUserType = () => {
        let pageData = {
            operation: "GetUserType"
        };

        fetch(global.variables.API_USEROPERATIONS_GETUSERTYPE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ userType: result.userType });
            });
    }

    createProject = async () => {
        //toast.success("Create Project!", {
        //    position: toast.POSITION.BOTTOM_RIGHT
        //});

        await this.setState({ isFetching: true });

        console.log(this.state);


        // Check if dot used on decimal places

        //if (this.state.totalBudget.includes(",") ||
        //    this.state.euContribution.includes(",") ||
        //    this.state.nationalCoFinancing.includes(",") ||
        //    this.state.otherCoFinancing.includes(",") ||
        //    this.state.mainComponentBudget.includes(",") ||
        //    this.state.totalFundsDisbursed.includes(",") ||

        //    this.state.totalBudget.split('.').length > 2 ||
        //    this.state.euContribution.split('.').length > 2 ||
        //    this.state.nationalCoFinancing.split('.').length > 2 ||
        //    this.state.otherCoFinancing.split('.').length > 2 ||
        //    this.state.mainComponentBudget.split('.').length > 2 ||
        //    this.state.totalFundsDisbursed.split('.').length > 2) {

        //    toast.warn("Use only dot for decimal seperator and don't use binary seperator", {
        //        position: toast.POSITION.BOTTOM_RIGHT
        //    });

        //} else {
        await fetch(global.variables.API_CREATEPROJECT, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Create Project Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    if (result.resultstate === 1 &&
                        result.errormessage !== null) {
                        toast.error(result.errormessage, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    } else {

                        toast.error("Create Project Failed!", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                }
            });
        // }

        await this.setState({ isFetching: false });
    };

    handletypeOfROMSelectChange = async (e, v) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ typeOfROM: v.TypeId });
        } else {
            await await this.setState({ typeOfROM: -1 });
        }

        console.log(e.target.name + ": " + e.target.value);
        console.log(this.state);
    }

    loadPage = async () => {
        await fetch(global.variables.API_CREATEPROJECT_LOADPAGE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    this.setState({
                        notAuthorized: false,
                        loading: false
                    });
                } else if (result.resultstate === 2) {
                    this.setState({
                        notAuthorized: true,
                        loading: false
                    });
                } else {
                    this.setState({
                        notAuthorized: true,
                        loading: false
                    });
                }
            });

        await this.loadBeneficiaries();
    }

    loadBeneficiaries = async () => {

        await fetch(global.variables.API_DEFINITIONS_GETLISTOFBENEFICIARIES, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate == 2) {
                    this.setState({
                        loading: false,
                        notAuthorized: true
                    });
                } else {
                    this.setState({
                        beneficiarieslist: result.listofbeneficiaries,
                        loading: false,
                        notAuthorized: false
                    });
                }
            });
    };

    render() {
        const {
            typeOfROM,
            projectTitle,
            projectNumber,
            status,
            typeOfProject,
            sector,
            smcsCode,
            cfcuContractManager,
            deuaSectorExpert,
            deuaMonitoringExpert,
            eudSectorManager,
            beneficiaryInstitution,
            beneficiaryUnitDepartment,
            contractingPartner,
            totalBudget,
            euContribution,
            nationalCoFinancing,
            otherCoFinancing,
            mainComponentBudget,
            totalFundsDisbursed,
            lastDateOfPayment,
            contractorSignatureDate,
            projectStartDate,
            finalDate,
            reasonfortheRomReview,
            romExpertName,
            coMonitor,
            fieldPhaseStartDate,
            fieldPhaseEndDate,
            contactAtBeneficiaryInstitution,
            teamLeaderPartner,
            annualType,
            IPAType,
            FAType,
            FAMAType,
            isFetching,
            beneficiaryInstitutionOptions,
            beneficiarieslist,
            userType,
        } = this.state;

        if (this.state.loading) {
            return (
                <Grid container spacing={3} >
                    <Grid item xs={12} className="mt-2" style={{ textAlign: "center", display: this.state.loading ? "block" : "none" }}>
                        <CircularProgress /> Loading...
                    </Grid>
                </Grid>
            );
        } else if (this.state.notAuthorized) {
            return (
                <p>You are not authorized</p>
            );
        } else {

            return (
                <Grid container spacing={3} >
                    <Grid item xs={6} height="100%">
                        <ProjectData
                            onChange={this.handleChange}
                            //onChangetypeOfROM={this.handletypeOfROMSelectChange}
                            //typeOfROM={typeOfROM}
                            projectTitle={projectTitle}
                            projectNumber={projectNumber}
                            //status={status}
                            userType={userType}
                        />
                    </Grid>
                    <Grid item xs={6} height="100%">
                        <ProjectKeyInformation
                            onChange={this.handleChange}
                            onSelectChange={this.handleSelectChange}
                            typeOfProject={typeOfProject}
                            sector={sector}
                            smcsCode={smcsCode}
                            annualType={annualType}
                            IPAType={IPAType}
                            FAType={FAType}
                            FAMAType={FAMAType}
                            userType={userType}
                        />
                    </Grid>
                    <Grid item xs={6} height="100%">
                        <EntityInCharge
                            onChange={this.handleChange}
                            onSelectChange={this.handleSelectChange}
                            onSelectChangeUseValue={this.handleSelectChangeUseValue}
                            sector={sector}
                            cfcuContractManager={cfcuContractManager}
                            deuaSectorExpert={deuaSectorExpert}
                            deuaMonitoringExpert={deuaMonitoringExpert}
                            eudSectorManager={eudSectorManager}
                            beneficiaryInstitution={beneficiaryInstitution}
                            beneficiaryUnitDepartment={beneficiaryUnitDepartment}
                            contactAtBeneficiaryInstitution={contactAtBeneficiaryInstitution}
                            contractingPartner={contractingPartner}
                            teamLeaderPartner={teamLeaderPartner}
                            beneficiaryInstitutionOptions={beneficiarieslist}
                            userType={userType}
                        />
                    </Grid>
                    <Grid item xs={6} height="100%">
                        <ProjectFinancialData
                            onChange={this.handleChange}
                            onChangeDate={(name, value) =>
                                this.handleChangeDate(name, value)
                            }
                            totalBudget={totalBudget}
                            euContribution={euContribution}
                            nationalCoFinancing={nationalCoFinancing}
                            otherCoFinancing={otherCoFinancing}
                            mainComponentBudget={mainComponentBudget}
                            totalFundsDisbursed={totalFundsDisbursed}
                            lastDateOfPayment={lastDateOfPayment}
                            userType={userType}
                        />
                    </Grid>
                    <Grid item xs={6} height="100%">
                        <ProjectDates
                            onChange={(name, value) => this.handleChangeDate(name, value)}
                            contractorSignatureDate={contractorSignatureDate}
                            projectStartDate={projectStartDate}
                            finalDate={finalDate}
                            userType={userType}
                        />
                    </Grid>
                    {
                        //<Grid item xs={6} height="100%">
                        //    <RomReview
                        //        onChangeDate={(name, value) =>
                        //            this.handleChangeDate(name, value)
                        //        }
                        //        onChange={this.handleChange}
                        //        reasonfortheRomReview={reasonfortheRomReview}
                        //        romExpertName={romExpertName}
                        //        coMonitor={coMonitor}
                        //        fieldPhaseStartDate={fieldPhaseStartDate}
                        //        fieldPhaseEndDate={fieldPhaseEndDate}
                        //    />
                        //</Grid>
                    }
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.createProject}
                            disabled={isFetching ? true : false}
                        >
                            Create Project
                    </Button>
                        {
                            //<Button
                            //    variant="contained"
                            //    color="primary"
                            //    onClick={() => {
                            //        console.log(stores.userStore.fullName);
                            //        stores.userStore.setFirstName("ayse");
                            //    }}
                            //>
                            //    Mobx Action
                            //</Button>
                        }
                    </Grid>
                    <Grid>
                        <ToastContainer />
                    </Grid>
                </Grid >
            );
        }
    }
}
)
);

export { CreateProjectPage };




// WEBPACK FOOTER //
// ./src/pages/CreateProjectPage.js